function applyVerticalMotion(className) {
    // Get elements by class name
    const elements = document.getElementsByClassName(className);

    // Iterate through each element and apply the animation
    for (let i = 0; i < elements.length; i++) {
        let element = elements[i];

        // Apply CSS animation to the element
        element.style.animation = 'moveUpDown 2s infinite alternate';
        element.style.position = 'relative'; // Ensure relative positioning for movement
    }

    // Create and inject CSS keyframes for up and down motion
    const styleSheet = document.createElement("style");
    styleSheet.type = "text/css";
    styleSheet.innerText = `
        @keyframes moveUpDown {
            0% { top: 0; }
            100% { top: -20px; } /* Adjust the value to control the distance */
        }
    `;
    document.head.appendChild(styleSheet);
}

// Call the function with the class name of your element
applyVerticalMotion('verticalMotion');
